"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIRST_PAYDAY_MAX = exports.MIN_SEMIMONTHLY_GAP_DAYS = void 0;
exports.secondPaydayRange = secondPaydayRange;
exports.semimonthlyGapOk = semimonthlyGapOk;
/**
 * How close the two paydays of a "Twice a month" stream may be (BEN-141 FP-056).
 *
 * The pickers kept the second day after the first, nothing more, so 14 and 15
 * were accepted and the pay periods became "Oct 14–Oct 14" then "Oct 15–Nov 13":
 * a one-day period, with every per-period figure computed on it. The month's turn
 * has the same hole: the 1st and the last day leave one day between them.
 * Twice-a-month pay is two paydays about two weeks apart, so each gap, inside the
 * month and across its turn, is at least a week.
 *
 * Day 31 means the last day of the month; a 30-day month stands in for it when
 * measuring the gap across the turn. February is shorter, so there the gap across
 * the turn can be 5 days (the 1st and the 24th: 1 + 28 - 24). Known, and left:
 * the point is ruling out one-day periods, not a calendar engine.
 */
exports.MIN_SEMIMONTHLY_GAP_DAYS = 7;
const LAST = 31;
const MONTH = 30;
/** The days the second payday may take, given the first (inclusive). */
function secondPaydayRange(first) {
    const lo = first + exports.MIN_SEMIMONTHLY_GAP_DAYS;
    const hiAcrossTurn = first + MONTH - exports.MIN_SEMIMONTHLY_GAP_DAYS;
    // Once the gap across the turn allows day 30, it allows the last day too.
    const hi = hiAcrossTurn >= MONTH ? LAST : hiAcrossTurn;
    return [lo, hi];
}
/** The latest first payday that still leaves a valid second one. */
exports.FIRST_PAYDAY_MAX = LAST - exports.MIN_SEMIMONTHLY_GAP_DAYS;
/** Whether a pair keeps both gaps a week or more. */
function semimonthlyGapOk(days) {
    if (days.length !== 2)
        return false;
    const [lo, hi] = secondPaydayRange(days[0]);
    return (days[0] >= 1 &&
        days[0] <= exports.FIRST_PAYDAY_MAX &&
        days[1] >= lo &&
        days[1] <= hi);
}
//# sourceMappingURL=semimonthlyGap.js.map